import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useWaitingMembersCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Fetch initial count
    const fetchCount = async () => {
      const { count: waitingCount, error } = await supabase
        .from("telehealth_sessions")
        .select("*", { count: "exact", head: true })
        .eq("status", "waiting");

      if (!error && waitingCount !== null) {
        setCount(waitingCount);
      }
    };

    fetchCount();

    // Subscribe to realtime changes
    const channel = supabase
      .channel("waiting-members-count")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "telehealth_sessions",
        },
        () => {
          // Refetch count on any change
          fetchCount();
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return count;
}
